import {getEoschemaFull} from "@/service/e-grid-service";

export default {
    state() {
        return {
            eoschemafull: []
        }
    },
    mutations: {
        setEosrcEoschemaFullDict(state, {dictName, data}) {
            state[dictName] = data;
            console.log(state[dictName]);
        }
    },
    actions: {
        async loadEosrcEoschemaFull({commit}, payload) {
            const data = await getEoschemaFull(payload);
            if (data && data.result) {
                commit('setEosrcEoschemaFullDict', {dictName: 'eoschemafull', data: data.data})
            }
        }
    }
}